export const generalKey = 'product_alt_charger_DC013_600';
export const whiteLocaleList = ['jp']; //白名单
export const productPageUrl = 'on-the-road-power-solution';
export const tabsValues = ['Product', 'Specs', 'Support'];
export const productPageTheme = 'white'; //主题色

export const generalKeys = [
    {
        key: 'product_alt_charger_DC013_600',
        url: '/on-the-road-power-solution-',
    },
    {
        key: 'product_alt_charger_DC013_560',
        url: 'on-the-road-power-solution',
    },
];
